import { Stack, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { t } from "i18next";
import { LucideGlobe } from "lucide-react";
import { type Dispatch, type SetStateAction } from "react";
import { useLanguageStore } from "../../../stores";

export function LanguageSelector({
  setOpenLanguageModal
} : {
  setOpenLanguageModal: Dispatch<SetStateAction<boolean>>
}) {
  const theme = useTheme();
  const language = useLanguageStore(state => state.language);

  return (
    <Stack
      alignItems="flex-end"
      zIndex={ theme.zIndex.fab }
    >
      { language && <Typography
        role="button"
        tabIndex={ 0 }
        aria-label={ t("language_select_header",{ language:language.label }) }
        textAlign="center"
        onClick={ () => {
          setOpenLanguageModal(true);
        } }
        onKeyDown={ (e) => {
          if (e.key === "Enter" || e.key === " ") setOpenLanguageModal(true);
        } }
        sx={ {
          "&:focus": {
            outline: "none"
          },
          "&:focus-visible": {
            outline: `2px solid ${theme.customColors.headerIcon}`,
            outlineOffset: "2px"
          },
          alignItems: "center",
          color: theme.customColors.headerIcon,
          cursor: "pointer",
          display: "flex",
          gap: 1,
          textAlign: "start"
        } }
      >
        <LucideGlobe
          aria-hidden="true"
          color={ theme.customColors.headerIcon }
          size={ 24 }
        />
        { `${ language.label} (${language.id?.toUpperCase()})` }
      </Typography> }
    </Stack>
  );
}
